<iframe
  #iframe
  sandbox="allow-same-origin"
  scrolling="no"
  frameborder="0"
></iframe>
